import map from './apiToDictMap';
import React from 'react';

const PLACEHOLDER_START = '{';
const EMPTY = '';

// Matches {key} or {{key}}
const R_REPLACE = /{{(.+?)}}|{(.+?)}/g;
const BRACKET_KEEP_REGEX = /(\{\{[a-zA-Z0-9]+\}\}|\{[a-zA-Z0-9]+\})/g;

const getDictKey = (key) => {
    return map[key] || key;
};

let replacementHolder = {};

const replaceKeys = (match, key1, key2) => {
    const key = key1 || key2; // Either from {{key}} or {key}
    return replacementHolder?.[key] ?? match;
};

/**
 * Retrieve a translation, by key, from a dictionary map.
 * @param  {object} dict        Key/value pair map of dictionary translations.
 * @param  {string} key         Key to retrieve.
 * @param  {[string]} fallback  Optional fallback text, in the event key is undefined.
 * @param  {[object]} replaceWith Optional replacement map of placeholder key/values. (ex: { name: "John" })
 * @return {string}             Translated value with placeholders resolved.
 */
const getTranslation = (dict = {}, key, fallback, replaceWith) => {
    const dictKey = getDictKey(key);
    let dictionaryItem = dict[dictKey] ? dict[dictKey] : (fallback || EMPTY);

    const isReplacementRequired =
    replaceWith && dictionaryItem.indexOf(PLACEHOLDER_START) >= 0;

    if (isReplacementRequired && dictionaryItem) {
        replacementHolder = replaceWith;
        dictionaryItem = dictionaryItem.replace(R_REPLACE, replaceKeys);
        replacementHolder = {};
    }

    return dictionaryItem;
};

/**
 * Retrieve a translation with passed comp wrapping keys, by key, from a dictionary map.
 * @param  {object} dict        Key/value pair map of dictionary translations.
 * @param  {string} key         Key to retrieve.
 * @param  {[string]} fallback  Optional fallback text, in the event key is undefined.
 * @param  {[object]} replaceWith Optional replacement map of placeholder key/values.
 * @return {string|Array}       Translated value with placeholders resolved.
 */
export const getDecoratedTranslation = (
    dict = {},
    key,
    fallback,
    replaceWith
) => {
    const dictKey = getDictKey(key);
    const dictionaryItem = dict[dictKey] ? dict[dictKey] : (fallback || EMPTY);

    const isReplacementRequired =
    replaceWith && dictionaryItem.indexOf(PLACEHOLDER_START) >= 0;

    let splitList = [];
    if (isReplacementRequired && dictionaryItem) {
        splitList = dictionaryItem.split(BRACKET_KEEP_REGEX).filter(Boolean);
        for (let i = 0; i < splitList.length; i++) {
            const item = splitList[i];
            if (item.startsWith('{')) {
                const cleanedItem = item.replace(/^\{\{?/, '').replace(/\}\}?$/, '');
                splitList[i] = (
                    <b key={i}>{replaceWith?.[cleanedItem] ?? cleanedItem}</b>
                );
            } else {
                splitList[i] = <span key={i}>{item}</span>;
            }
        }
    }

    return splitList.length ? splitList : dictionaryItem;
};

export default getTranslation;
